import React  from 'react';
import { number, string, bool, func, array } from 'prop-types';
import { Link } from 'react-router';

import cx from 'classnames';
import s from './MessageThreadHeaderListItem.css';


const MessageThreadHeaderListItem = ({ ...props }) => {

  const handleClick = (e) => {
    e.preventDefault();
    props.handleMsgThreadDisplay(props.id);

    // toggling of blue background-color when selected handled in the parent list
    props.onItemActive(props.id);
  };

  const unreadStyle = !props.read ? s.hasUnreads : '';
  const selectedStyle = props.active ? s.selected : '';
  const threadCount = props.threadcount >= 2 ? `(${props.threadcount})` : null;

  // We do not have an actual "sender" in our response yet. Subject is being used for that display.
  return (
    <article className={cx(s.component, unreadStyle, selectedStyle)} id={props.id}>
      <Link
        to={`/${props.id}`}
        className={s.vcard}
        onClick={handleClick}
      >
        <p className={s.sender}>
           {props.subject}
        </p>
        <div className={s.msgBody}>
          <p className={s.content}>
            {props.content}
          </p>
        </div>
        <div className={s.msgBody}>
          <p className={cx(s.timestamp, s.content)}>
            {threadCount} {props.timestamp}
          </p>
        </div>
      </Link>
    </article>
  );

};

MessageThreadHeaderListItem.propTypes = {
  id: number,
  subject: string,
  content: string,
  timestamp: string,
  threadcount: number,
  read: bool,
  onItemActive: func,
  active: bool,
  handleCheckboxToggle: func,
  messageThreadHeaders: array,
  handleMsgThreadDisplay: func,
};

export default MessageThreadHeaderListItem;



// WEBPACK FOOTER //
// ./src/components/Pages/Messages/MessageThreadHeaderListItem/MessageThreadHeaderListItem.js